export function ctaMatter() {

let matterwrap = document.querySelector('.cta_bg'),
    w = window.innerWidth,
    h = document.querySelector('.cta_bg').offsetHeight;


var Engine = Matter.Engine,
    Render = Matter.Render,
    Runner = Matter.Runner,
    Composites = Matter.Composites,
    Common = Matter.Common,
    MouseConstraint = Matter.MouseConstraint,
    Mouse = Matter.Mouse,
    Composite = Matter.Composite,
    Bodies = Matter.Bodies;

    // Common.setDecomp(require('poly-decomp'));

  // create engine
  var engine = Engine.create(),
      world = engine.world;

  // enable Zero gravity
//   world.gravity.y = 1;

  // create renderer
  var render = Render.create({
      element: matterwrap,
      engine: engine,
      options: {
          width: w,
          height: h,
          showAngleIndicator: false,
          wireframes: false,
          background: 'rgb(0,0,0)'
      }
  });

  Render.run(render);

  // create runner
  var runner = Runner.create();
  Runner.run(runner, engine);

  // add bodies
//   var stack = Composites.stack(100, -500, 4, 3, 20, 20, function(x, y) {
//       var sides = Math.round(Common.random(1, 8));

//       // round the edges of some bodies
//       var chamfer = null;
//       if (sides > 2 && Common.random() > 0.7) {
//           chamfer = {
//               radius: 10
//           };
//       }

//       switch (Math.round(Common.random(0, 1))) {
//             case 0:
//                 if (Common.random() < 0.8) {
//                     return Bodies.rectangle(x, -200, 200, 200, {
//                         chamfer: chamfer,
//                         density: 0.0005,
//                         frictionAir: 0.06,
//                         restitution: 0.3,
//                         friction: 0.01,
//                         render: {
//                             fillStyle: 'transparent',
//                             strokeStyle: '#FFFFFF',
//                             lineWidth: 1,
//                             sprite: {
//                                 texture: window.location.origin + '/assets/images/placeholder.png',
//                                 xScale: 0.416,
//                                 yScale: 0.416,
//                             }
//                         }
//                     });
//                 } else if (Common.random() < 0.3) {
//                     return Bodies.rectangle(x, -200, 100, 400, {
//                         chamfer: 0,
//                         density: 0.0005,
//                         frictionAir: 0.06,
//                         restitution: 0.3,
//                         friction: 0.01,
//                         render: {
//                             fillStyle: 'red',
//                             strokeStyle: 'transparent',
//                             lineWidth: 0
//                         }
//                     });
//               } else {
                
//                 return Bodies.circle(x, -300, 200, {
//                     chamfer: 0,
//                     density: 0.0005,
//                     frictionAir: 0.06,
//                     restitution: 0.3,
//                     friction: 0.01,
//                     render: {
//                         fillStyle: 'transparent',
//                         strokeStyle: 'white',
//                         lineWidth: 2
//                     }
//                 });
                

                
//                 //     return Bodies.rectangle(x, -200, Common.random(150, 200), Common.random(150, 200), {
//                 //       chamfer: chamfer,
//                 //       render: {
//                 //           fillStyle: 'transparent',
//                 //           strokeStyle: '#FFFFFF',
//                 //           lineWidth: 1
//                 //       }
//                 //   });
//               }
//           case 1:
//             return Bodies.rectangle(w/2, -200, 4, 600, {
//                 chamfer: 0,
//                 density: 0.0005,
//                 frictionAir: 0.06,
//                 restitution: 0.3,
//                 friction: 0.01,
//                 render: {
//                     fillStyle: 'white',
//                     strokeStyle: 'transparent',
//                     lineWidth: 0,
//                 }
//             });
//             //   return Bodies.polygon(x, -200, sides, Common.random(100, 150), {
//             //       chamfer: chamfer,
//             //       render: {
//             //           fillStyle: 'transparent',
//             //           strokeStyle: '#FFFFFF',
//             //           lineWidth: 1
//             //       }
//             //   });
//       }
//   });

//   Composite.add(world, stack);

  
    // bounds (keep the shapes within the canvas)
    Composite.add(world, [
        // bottom
        Bodies.rectangle(0, h+24, w * 2, 50, {
            isStatic: true,
            render: {
                fillStyle: 'black',
                lineWidth: 0
            }
        }),
        // right
        Bodies.rectangle(w+25, h / 2, 50, h, {
            isStatic: true,
            render: {
                fillStyle: 'black',
                lineWidth: 0
            }
        }),
        
        // left
        Bodies.rectangle(0-25, h / 2, 50, h, {
            isStatic: true,
            render: {
                fillStyle: 'black',
                lineWidth: 0
            }
        }),

        // center circle
        Bodies.circle(w/2, -h/2, 250, {
            density: 0.001,
            frictionAir: 0.001,
            restitution: 0.4,
            friction: 0.01,
            isStatic: false,
            render: {
                fillStyle: 'transparent',
                strokeStyle: '#E70074',
                lineWidth: 0,
                sprite: {
                    texture: window.location.origin + '/assets/images/grav-centrecircle.png',
                    // xScale: 0.416,
                    // yScale: 0.416,
                }
            }
        }),

        // Bodies.rectangle(w/2+100, -h, 870, 1, {
        //     // density: 0.001,
        //     frictionAir: 0.001,
        //     restitution: 0.7,
        //     // friction: 0.01,
        //     // isStatic: false,
        //     render: {
        //         fillStyle: 'transparent',
        //         strokeStyle: '#E70074',
        //         lineWidth: 1
        //     }
        // }),

        Bodies.rectangle(100, -h, 170, 300, {
            density: 1,
            frictionAir: 0.001,
            restitution: 0.4,
            // friction: 0.01,
            isStatic: false,
            render: {
                fillStyle: 'yellow',
                strokeStyle: 'transparent',
                lineWidth: 0,
                sprite: {
                    texture: window.location.origin + '/assets/images/grav-boxleftinner.png',
                    // xScale: 0.416,
                    // yScale: 0.416,
                }
            }
        }),
        

        Bodies.rectangle(500, -h/2, 300, 580, {
            density: 1,
            frictionAir: 0.001,
            restitution: 0.4,
            // friction: 0.01,
            isStatic: false,
            render: {
                fillStyle: 'transparent',
                strokeStyle: 'transparent',
                lineWidth: 0,
                sprite: {
                    texture: window.location.origin + '/assets/images/grav-boxleftouter.png',
                    // xScale: 0.416,
                    // yScale: 0.416,
                }
            }
        }),

        // Bodies.rectangle(w-200, -h, 170, 300, {
        //     // density: 0.001,
        //     frictionAir: 0.001,
        //     restitution: 0.7,
        //     // friction: 0.01,
        //     // isStatic: false,
        //     render: {
        //         fillStyle: 'transparent',
        //         strokeStyle: '#E70074',
        //         lineWidth: 3
        //     }
        // }),

        // Bodies.rectangle(w-300, -h, 300, 580, {
        //     // density: 0.001,
        //     frictionAir: 0.001,
        //     restitution: 0.7,
        //     // friction: 0.01,
        //     // isStatic: false,
        //     render: {
        //         fillStyle: 'transparent',
        //         strokeStyle: '#E70074',
        //         lineWidth: 3
        //     }
        // }),
  ]);



  // add mouse control
  var mouse = Mouse.create(render.canvas),
      mouseConstraint = MouseConstraint.create(engine, {
          mouse: mouse,
          constraint: {
              stiffness: 0.01,
              render: {
                  visible: false
              }
          }
      });
  // prevent hijacking mousewheel for matter
  mouse.element.removeEventListener("mousewheel", mouse.mousewheel);
  mouse.element.removeEventListener("DOMMouseScroll", mouse.mousewheel);

  Composite.add(world, mouseConstraint);

  // keep the mouse in sync with rendering
  render.mouse = mouse;

  // fit the render viewport to the scene
  Render.lookAt(render, {
      min: {
          x: 0,
          y: 0
      },
      max: {
          x: w,
          y: h
      }
  });


}
